<template>
	<component :is="iconComponent" v-if="iconComponent" />
</template>

<script setup lang="ts">
import type { Component } from "vue";

interface Props {
	name: string;
}

const props = defineProps<Props>();

// Pre-register all icon components at build time using glob
// Exclude index.vue to prevent circular reference
const iconModules = import.meta.glob<{ default: Component }>(["./*.vue", "!./index.vue"], { eager: true });

const iconComponents = Object.fromEntries(
	Object.entries(iconModules).map(([path, module]) => {
		const name = path.replace(/^\.\/(.*)\.vue$/, "$1");
		return [name, (module as { default: Component }).default];
	}),
) as Record<string, Component>;

const availableIcons = Object.keys(iconComponents);

const iconComponent = computed(() => {
	const iconName = props.name;
	if (!iconName) return null;

	if (!/^[a-zA-Z][a-zA-Z0-9]*$/.test(iconName)) {
		console.warn(`[Icon] Invalid icon name format: "${iconName}"`);
		return null;
	}

	const component = iconComponents[iconName];

	if (!component) {
		console.warn(`[Icon] Icon "${iconName}" not found. Available: ${availableIcons.join(", ")}`);
		return null;
	}

	return component;
});
</script>
